import { environmentService, getRequestHandler,  postRequestHandler } from '@/utils/services';

const state = {
  // countries : [],
  countries: (() => {
    try {
      const storedCountries = localStorage.getItem('countries');
      return storedCountries ? JSON.parse(storedCountries) : [];
    } catch (e) {
      console.error("Error al parsear countries desde localStorage", e);
      return [];
    }
  })(),
  countryList: [],
  selectedCountry: null,
  cities: [],
  towns : [],
  apiUrl : null,
  apiUrlBooking : null,
  headers : null
},

getters = {
  countries : (state,getters, rootState) => {
    if (rootState.availability.selectedCurrency==2){
      return state.countries.filter(country => country.name!='Chile');
    }
    return state.countries;
  },
  cities: state => state.cities,
  selectedCountry: state => state.selectedCountry,
  countriesWithTowns: state => state.countryList,
  towns: state => state.towns
},

mutations = {
  getCountries(state, payload){
    state.countries=payload;
    // almacenamiento local
    localStorage.setItem('countries', JSON.stringify(payload));
  },

  getTowns(state,payload){
    state.towns=payload;
  },

  setLocationUrls(state, payload){
    state.apiUrl = environmentService.apiUrlHotel;
    state.apiUrlBooking = environmentService.apiUrlBooking;
    state.headers = {headers:payload.headers};
  },

  setCountryList(state, payload){
    state.countryList = payload;
  },

  setCities(state, payload){
    state.cities = payload
  },
  setSelectedCountry(state, payload){
    state.selectedCountry = {countryId: payload}
  }
},

actions = {
  setSelectedCountry({ commit, state, dispatch }, payload){
    commit('setSelectedCountry', payload);
    dispatch('getTownsByCountry')
  },

  async getCountries({ commit, state }){
    if (state.countries.length == 0) {
      let payload = await getRequestHandler(`${state.apiUrlBooking}/countries`, state.headers);
      commit('getCountries',  payload);
    };
  },

  async getCountriesWithTowns({ commit, state }){
    if (state.countryList.length == 0) {
      let payload = await getRequestHandler(`${state.apiUrlBooking}/countries/towns`, state.headers);
      commit('setCountryList',  payload);
    };
  },

  async getTowns({ commit, state }){
    if (state.towns.length ==0){
      let payload = await getRequestHandler(`${state.apiUrl}/towns`, state.headers);
      commit('getTowns', payload);
    }
  },

  async getTownsByCountry({ commit, state }){
    let result = await postRequestHandler(`${state.apiUrl}/towns/country`, state.selectedCountry, state.headers);
    commit('setCities', result.data);
  },

  setLocationUrls({ commit, rootState }){
    commit('setLocationUrls', {headers: rootState.auth.headers});
  }
};

export default {
  namespaced:true,
  state,getters,mutations,actions
};



// WEBPACK FOOTER //
// ./src/store/modules/location.js